import Cookies from 'js-cookie';
import getUserNewsletterSubscriptions from 'lib/personalizationApi/getUserNewsletterSubscriptions';

export const getOptimizelyAttributes = async (pageAdConfig) => {
  const attributes: Record<string, any> = {};
  if (typeof window !== 'undefined') {
    const userAgent = navigator.userAgent;
    if (/Mobi|Android/i.test(userAgent)) {
      attributes.deviceType = 'Mobile';
    } else if (/Tablet|iPad/i.test(userAgent)) {
      attributes.deviceType = 'Tablet';
    } else {
      attributes.deviceType = 'Desktop';
    }

    if (userAgent.indexOf('Chrome') > -1) {
      attributes.browserType = 'Chrome';
    } else if (userAgent.indexOf('Firefox') > -1) {
      attributes.browserType = 'Firefox';
    } else if (userAgent.indexOf('Safari') > -1) {
      attributes.browserType = 'Safari';
    } else if (userAgent.indexOf('Edge') > -1) {
      attributes.browserType = 'Edge';
    } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) {
      attributes.browserType = 'IE';
    } else {
      attributes.browserType = 'Unknown';
    }

    // UTM Parameters
    const urlParams = new URLSearchParams(window.location.search);
    attributes.utm = '';
    urlParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        attributes.utm += `${key}=${value}&`;
      }
    });
    // Remove trailing '&' if exists
    if (attributes.utm.endsWith('&')) {
      attributes.utm = attributes.utm.slice(0, -1);
    }
  }

  attributes.siteSection = pageAdConfig?.ch || 'Unknown';
  attributes.tags = pageAdConfig?.tags ? pageAdConfig.tags.join(',') : 'None';
  attributes.topics = pageAdConfig?.topics ? pageAdConfig.topics.join(',') : 'None';

  // Determine login / subscription / visitor cookies
  const pianoUid = Cookies.get('pianoUid');
  const loggedIn = !!pianoUid;
  const anonVisitorCookie = !!Cookies.get('anonUserOptimizely');
  const userEmail = Cookies.get('userEmail');

  attributes.isLoggedIn = loggedIn;
  attributes.isSubscriber = Cookies.get('pianoAccess') === 'true';

  // referer (safe in non-browser environments)
  const referer = typeof document !== 'undefined' ? document.referrer || '' : '';
  try {
    attributes.referer = referer ? new URL(referer).hostname : 'Direct';
  } catch {
    attributes.referer = referer || 'Direct';
  }

  // Optimizely audience segments required
  // newVisitor = Not Subscribed / No Cookies
  attributes.newVisitor = !attributes.isSubscriber && !anonVisitorCookie && !attributes.isLoggedIn && !userEmail;

  // returningVisitor = Not Subscribed / Not Logged In but with a known visitor cookie
  attributes.returningVisitor = !attributes.isSubscriber && !attributes.isLoggedIn && anonVisitorCookie;

  // loginUser = Not Subscribed, but have a Piano login and are logged in
  attributes.loggedinUser = !attributes.isSubscriber && attributes.isLoggedIn;

  // loginSubscriber = Subscribed and Logged In
  attributes.loggedinSubscriber = attributes.isSubscriber && attributes.isLoggedIn;

  // loggedOutUser = Not Subscribed, but have a login and are not logged in
  // We infer "have a login" from presence of a known userEmail cookie when not logged in
  attributes.loggedOutUser = !attributes.isSubscriber && !attributes.isLoggedIn && !!userEmail;

  // loggedOutSubscriber = Subscribed, but are not logged in
  attributes.loggedOutSubscriber = attributes.isSubscriber && !attributes.isLoggedIn && !!userEmail;

  // Fortune Email Subscriber
  if (attributes.isLoggedIn && userEmail) {
    try {
      // TODO: shouldn't this be an endpoint? it's exposing our api keys
      const subscriptions = await getUserNewsletterSubscriptions(userEmail);
      attributes.isFortuneEmailSubscriber = subscriptions && subscriptions.length > 0;
    } catch {
      attributes.isFortuneEmailSubscriber = false;
    }
  } else {
    attributes.isFortuneEmailSubscriber = false;
  }

  attributes.geography = Cookies.get('__pil') || 'Unknown';

  return attributes;
};
